import Alarms from './Alarms';
import AlarmsContainer from './AlarmsContainer';

export { AlarmsContainer };
export default Alarms;



// WEBPACK FOOTER //
// ./src/components/Alarms/index.js